<template>
  <div class="page">
    <section class="section content-container">
      <div class="container is-fluid">
        <div class="report-container island">
          <BillableConversationsTrendChart
            :data="chartData.billableConversationsTrendReport"
            :loadedData="loadedData"
            :loadingError="loadingError"
          />
        </div>
        <div class="report-container island">
          <ProactiveTriggersTrendChart
            :data="chartData.proactiveTriggersTrendReport"
            :loadedData="loadedData"
            :loadingError="loadingError"
          />
        </div>
        <div class="report-container island">
          <ChannelMessagesTrendChart
            :data="chartData.channelMessagesTrendReport"
            :loadedData="loadedData"
            :loadingError="loadingError"
          />
        </div>
      </div>
    </section>
  </div>
</template>

<script lang="ts" setup>
import { SET_REPORT_LOADING } from '@/store/reports/mutationTypes';
import ProactiveTriggersTrendChart from '@/features/reports/components/usage/ProactiveTriggersTrendChart.vue';
import BillableConversationsTrendChart from '@/features/reports/components/usage/BillableConversationsTrendChart.vue';
import ChannelMessagesTrendChart from '@/features/reports/components/usage/ChannelMessagesTrendChart.vue';
import { usageReportsApi, UsageReportsData } from '@/features/reports/services/usageReportsApi';
import { DatePicker } from '@/features/reports/services';
import { useStore } from 'vuex';
import { computed, ref, watch } from 'vue';

const store = useStore();
const currentWorkspace = computed(() => store.getters.currentWorkspace);
const selectedDateOption = computed(() => store.getters.selectedDateOption);

const setLoading = (loading: boolean) => store.commit(SET_REPORT_LOADING, loading);

const chartData = ref<UsageReportsData>({
  proactiveTriggersTrendReport: {
    scale: {
      title: '',
      labels: [],
    },
    series: [],
  },
  billableConversationsTrendReport: {
    scale: {
      title: '',
      labels: [],
    },
    series: [],
  },
  channelMessagesTrendReport: {
    scale: {
      title: '',
      labels: [],
    },
    series: [],
  },
});

const loadingError = ref(false);
const loadedData = ref(false);

watch(
  selectedDateOption,
  async (filter, previous) => {
    if (filter && filter === previous) {
      return;
    }

    await loadData();
  },
  { immediate: true },
);

async function loadData() {
  if (!DatePicker.isValidMonthOption(selectedDateOption.value)) {
    return; // Invalid selection, will be corrected in the date filter and this will be called again
  }

  loadedData.value = false;
  loadingError.value = false;
  setLoading(true);
  try {
    chartData.value = await usageReportsApi.loadData(currentWorkspace.value.id, {
      startDate: selectedDateOption.value.getDateRange().start,
      endDate: selectedDateOption.value.getDateRange().end,
    });
    loadedData.value = true;
  } catch {
    loadingError.value = true;
  } finally {
    setLoading(false);
  }
}
</script>

<style scoped lang="scss">
.island {
  height: 560px;
}

.report-container:not(:last-child) {
  margin-bottom: 1.5em;
}
</style>
